import React from 'react';
import { PromoBar } from './components/PromoBar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { MainProduct } from './components/MainProduct';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { StickyMobileCta } from './components/StickyMobileCta';
export function App() {
  return <div lang="fr" className="min-h-screen w-full bg-ink text-cream" data-id="element-0" data-mp="31c1l6kv02akh">
      <PromoBar data-id="element-1" data-mp="2wj8cjlweui34" />
      <Hero data-id="element-2" data-mp="2wip6b2g4hi4x" />
      <main data-id="element-3" data-mp="2whxbhtucnofp">
        <PainPoints data-id="element-4" data-mp="28ufpkexrnkkn" />
        <MainProduct data-id="element-5" data-mp="28tw5arkn8k3g" />
        <Bonuses data-id="element-6" data-mp="28te37ebavbnm" />
        <HowItWorks data-id="element-7" data-mp="28suv0pbgc1ms" />
        <Testimonials data-id="element-8" data-mp="28s2xva27hvue" />
        <Offer data-id="element-9" data-mp="23vkuoemiy5k6" />
        <Guarantee data-id="element-10" data-mp="23w4g45bdvc2y" />
        <Faq data-id="element-11" data-mp="23ujlygszdv5m" />
        <FinalCta data-id="element-12" data-mp="23v2r0wxj8p28" />
      </main>
      <StickyMobileCta data-id="element-13" data-mp="3ijxnsm94vshs" />
    </div>;
}